import Chip from '@ben/orion/chip';
import Loader from '@ben/orion/loader';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { Group, Stack, Text } from '@mantine/core';
import styled from 'styled-components';
import { DomainSection } from './domain-section';
import { REQUIREMENT_STATUS_FILTERS } from './status';
import { useGroupDetail } from './use-group-detail';

export const RequirementsSection = () => {
  const {
    statusCounts,
    chipCounts,
    statusFilter,
    onFilterChange,
    requirementsLoading,
    visible,
    matching,
    truncated,
    sections,
    totalsByDomain,
    openRequirement,
    onSelectRequirement,
  } = useGroupDetail();

  if (!statusCounts) return null;

  return (
    <section>
      <Group gap="sm">
        <Typography variant={TypographyVariant.h2}>Requirements</Typography>
        <Text size="sm" c="dimmed">
          {statusCounts.total}
        </Text>
      </Group>
      <Text size="sm" c="dimmed">
        Grouped by the part of the benefit each one configures. Select one to
        see its answer, evidence and history.
      </Text>

      {requirementsLoading ? <Loader /> : null}

      {statusCounts.total > 0 ? (
        <Filters>
          <Chip.Group value={statusFilter} onChange={onFilterChange}>
            {REQUIREMENT_STATUS_FILTERS.map((filter) => (
              <Chip key={filter.value} value={filter.value}>
                {filter.label} {chipCounts[filter.value] ?? 0}
              </Chip>
            ))}
          </Chip.Group>
        </Filters>
      ) : null}

      {!requirementsLoading && visible.length === 0 ? (
        <Text size="sm" c="dimmed">
          {statusCounts.total === 0
            ? 'Nothing captured for this group yet.'
            : 'No requirements match this filter.'}
        </Text>
      ) : null}

      {truncated ? (
        <Text size="sm" c="dimmed">
          Showing the first {visible.length} of {matching}. Narrow it with a
          filter above.
        </Text>
      ) : null}

      <Stack gap="sm">
        {sections.map((section) => (
          <DomainSection
            key={section.domain ?? 'none'}
            section={section}
            totals={
              totalsByDomain.get(section.domain) ?? {
                total: section.requirements.length,
                outstanding: 0,
                unanswered: 0,
              }
            }
            openRequirementId={openRequirement?.id}
            onSelect={onSelectRequirement}
          />
        ))}
      </Stack>
    </section>
  );
};

const Filters = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
